export const pedigreeImportES = {
  'Import': 'Import',
  Cancel: 'Cancel',
  'Loading': 'Loading...',
  Ok: 'Ok',
  'Load Format': 'Load Format',
  'Save Format': 'Save Format',
  Browse: 'Browse',
  'Import Type': 'Import Type',
  Pedigrees: 'Pedigrees',
  Individuals: 'Individuals',
  Tab: 'Tab',
  Comma: 'Comma',
  Other: 'Other',
  'File Delimiter': 'File Delimiter',
  'Import Options': 'Import Options',
  'Male Value': 'Male Value',
  'Female Value': 'Female Value',
  'Deceased Value': 'Deceased Value',
  'Pedigree Name, Individual Name, Mother ID, Father ID, and Gender are required fields for successfully importing a pedigree': 'Pedigree Name, Individual Name, Mother ID, Father ID, and Gender are required fields for successfully importing a pedigree',
  'File has a Header Row': 'File has a Header Row',
  'Auto Build': 'Auto Build',
  'Right-click on headers to specify columns': 'Right-click on headers to specify columns',
  'New Folder': 'New Folder',
  'Delete Folder': 'Delete Folder',
  'Delete Format': 'Delete Format',
  'Format Name': 'Format Name',
  'Add Format Folder': 'Add Format Folder',
  'Folder Name': 'Folder Name',
  'Are you sure you want to delete this folder? All formats in this folder will also be deleted': 'Are you sure you want to delete this folder? All formats in this folder will also be deleted',
  'Confirmation Message': 'Confirmation Message',
  'Operation failed': 'Operation failed',
  'Warning': 'Warning',
  'Are you sure you want to delete this format?': 'Are you sure you want to delete this format?',
  'Right-click on headers to specify columns': 'Right-click on headers to specify columns',
  'Modified By': 'Modified By',
  'Last Modified': 'Last Modified',
  'Update Individual if Found': 'Update Individual if Found',
  'Ignore blank cells': 'Ignore blank cells',
  'Import blank cells over existing data': 'Import blank cells over existing data',
  'Right-click on headers to specify columns': 'Right-click on headers to specify columns',
  'Choose Existing Field': 'Choose Existing Field',
  'Please, specify file delimiter': 'Please, specify file delimiter',
  'Failed to upload file': 'Failed to upload file',
  'Operation canceled': 'Operation canceled',
  'Failed to auto build': 'Failed to auto build',
  'Failed to create a format': 'Failed to create a format',
  'Failed to create a folder': 'Failed to create a folder',
  'Failed to import': 'Failed to import',
  'There are names in your header row that we could not match because of no match or multiple matches found to fields in the database': 'There are names in your header row that we could not match because of no match or multiple matches found to fields in the database',
  'Pedigree name': 'Pedigree name',
  'Individual Name': 'Individual Name',
  'Mother ID': 'Mother ID',
  'Father ID': 'Father ID',
  'Gender': 'Gender',
  'Child': 'Child',
  'Sibling': 'Sibling',
  'Spouse 1': 'Spouse 1',
  'Spouse 2': 'Spouse 2',
  'Twin Status': 'Twin Status',
  'Twin Relationship': 'Twin Relationship',
  'Proband Status': 'Proband Status',
  'Deceased': 'Deceased',
  'Failed to delete folder': 'Failed to delete folder',
  'Failed to delete format': 'Failed to delete format',
  'Individual Name and Gender are required fields for successfully importing an Individual': 'Individual Name and Gender are required fields for successfully importing an Individual'
};